import type {
  ColorPartial,
  PaletteOptions,
  SimplePaletteColorOptions,
  TypeBackground,
  TypeText
} from '@mui/material/styles/createPalette';

type FullColorPaletteOptions = SimplePaletteColorOptions & ColorPartial;

type ColorPaletteOptions = FullColorPaletteOptions | SimplePaletteColorOptions | ColorPartial;

export interface DefaultPaletteOptions extends PaletteOptions {
  primary: FullColorPaletteOptions;
  green: ColorPaletteOptions & FullColorPaletteOptions;
  orange: FullColorPaletteOptions;
  red: FullColorPaletteOptions;
  lightBlue: ColorPaletteOptions;
  background: TypeBackground & { light: string };
  grey: ColorPartial;
  text: Partial<TypeText>;
  error: SimplePaletteColorOptions;
}

const palette: DefaultPaletteOptions = {
  primary: {
    main: '#2F409D',
    1000: '#1B2770',
    900: '#26348B',
    700: '#384CBC',
    600: '#5264CB',
    500: '#7280D5',
    400: '#919EDE',
    300: '#B0B9E8',
    250: '#CFD4F2',
    200: '#DFE2F6',
    100: '#EFF1FB',
    50: '#F7F8FD'
  },
  green: {
    main: '#1EAE5A',
    50: '#FBFEFC',
    100: '#F6FDF9',
    200: '#EEFCF4',
    700: '#23CE6B',
    900: '#1B9D51'
  },
  orange: {
    main: '#EA9010',
    1100: '#7C4C08',
    900: '#D2800F',
    300: '#FDF6EC'
  },
  red: {
    main: '#D33A3D',
    300: '#FDE8E8',
    900: '#C82D30',
    1000: '#B72A2C',
    1100: '#701A1B'
  },
  lightBlue: {
    main: '#E5F2FD',
    dark: '#D0E7FB'
  },
  text: {
    primary: '#080B14'
  },
  background: {
    default: '#FFFFFF',
    paper: '#F6F6F6',
    light: '#FAFAFA'
  },
  grey: {
    50: '#FAFAFA',
    100: '#FBFBFB',
    200: '#F6F6F6',
    300: '#F2F2F2',
    400: '#E2E2E2',
    500: '#CFCFD0',
    600: '#B5B6B7',
    700: '#8E8F93',
    800: '#676B77',
    900: '#484D5D',
    A100: 'rgba(0, 0, 0, 0.02)'
  },
  error: {
    main: '#D33A3D'
  }
};

export default palette;
